export const getExpirationDateFromNow = (expirationDaysFromNow) => {
	const expirationDaysInt = parseInt(expirationDaysFromNow);

	if (isNaN(expirationDaysInt)) {
		return null;
	}

	let expirationDate = new Date();
	expirationDate.setDate(expirationDate.getDate() + expirationDaysInt);

	return expirationDate;
};

export const setCookie = (cookieName, value, expirationDate = null) => {
	if (typeof value == 'object') {
		value = JSON.stringify(value);
	}

	let cookie = `${cookieName}=${encodeURIComponent(value)}; path=/`;

	if (expirationDate && expirationDate.getTime()) {
		cookie += `; expires=${expirationDate.toUTCString()}`;
	}

	document.cookie = cookie;
};

export const getCookie = (cookieName) => {
	const cookieValue = document.cookie
		.split('; ')
		.find((row) => row.startsWith(cookieName + '='))
		?.split('=')[1];

	return decodeURIComponent(cookieValue);
};

export const removeCookie = (cookieName) => {
	setCookie(cookieName, '', -1);
};
